import EventController from "../../event_controller";

export default class extends EventController {
  eventProperties(baseProperties, _eventType, _node, _target) {
    return { ...baseProperties, offer_id: null };
  }
}
